import React, { useContext, useEffect } from "react";
import { createUseStyles } from "react-jss";
import { EmpdContext } from '../../../../../Context'
import DashboardCard from "./DashboardCard";
import classNames from "classnames";
import Button from "../../../../../Components/Button";
import { questionSquare } from "../../../../../Assets/Images";

interface Props {
  className?: string;
}

const useStyles = createUseStyles({
  root: {},
  diagnosedButton: {
    flexBasis: "41%",
    textAlign: "center",
  },
  diagnosedQuestion: {
    padding: 30,
    backgroundColor: "#f6bb6021",
    border: "1px solid #f6bb60",
    borderRadius: "5px",
  },
  diagnosedQuestionHeader: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    "& h4": {
      fontSize: "1.35em",
      margin: 0,
    },
  },
  notDiagnosedButton: {
    backgroundColor: "#e1e5ec !important",
    flexBasis: "41%",
    textAlign: "center",
  },
  diagnosedContainer: {
    marginTop: "50px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  questionMark: {
    height: 25,
    width: "auto",
    marginRight: 15,
  },
});

const useMyContext = () => {
    const context = useContext(EmpdContext)
    if( !context ) {
        throw new Error("No provider found for Context")
    }
    return context
}

const NonUsCitizenCard = ({ className }: Props) => {
  const context = useMyContext()
  const { isLoading } = context
  const classes = useStyles();

  return (
    <DashboardCard
      title={'Thank you for registering'}
      className={classNames(classes.root, className)}
    >
      {!isLoading && (
      <div className={classes.diagnosedQuestion}>
        <div className={classes.diagnosedQuestionHeader}>
		  	<img
            	src={questionSquare}
	            alt="question-mark"
    	        className={classes.questionMark}
        	  />
          <h4>{"Thank you for your interest"}</h4>
        </div>
        <p>{"At this time, the EMPD research program is open only to participants in the United States. If you live outside the U.S., you can still learn about the program, read about our research and follow updates. We hope to welcome international participants in the future."}</p>
      </div>
      )}
    </DashboardCard>
  );
};

export default NonUsCitizenCard;
